import colors from "../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const AssessmentResultsStyle = makeStyles((theme) => ({
	activeMainContainer: {
		opacity: 1,
		pointerEvents: "all",
	},
	inactiveMainContainer: {
		opacity: 0.5,
		pointerEvents: "none",
	},
	headerContainer: {
		width: "100%",
		padding: "20px 10px",
		marginTop: "20px",
		borderBottom: `4px solid ${colors.primary}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: colors.veryPaleGray,
	},
	headerInner: {
		textAlign: "center",
		maxWidth: 900,
	},
	headerMainText: {
		color: colors.charcoalGray,
		fontWeight: 600,
		marginBottom: "6px",
	},
	headerSubText: {
		color: colors.mediumGray,
		fontWeight: 400,
		margin: "0 auto",
	},
	loaderContainer: {
		color: colors.primary,
		margin: "40px",
		justifyContent: "center",
		display: "flex",
	},
	dataLoaderContainer: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		color: colors.primary,
		zIndex: 1000,
		opacity: 1,
	},
	dataLoader: {
		opacity: 1,
	},
	footer: {
		width: "100%",
		height: "60px",
		backgroundColor: "transparent",
		marginTop: "40px",
	},
}));

export default AssessmentResultsStyle;
